/**
 * Canonical cn() helper (clsx + tailwind-merge).
 * Heavy usage (~150 imports) — kept at this stable path to avoid churn.
 * Mirrored as @/shared/core/utils for the shared layer.
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
